import { useEffect, useState } from "react";

export type RecordingInfo = { seconds: number; bytes: number };

/** MP3 recordings of the spoken translation, offered once the session has ended. */
export function useRecordings(code: string, ended: boolean) {
  const [recordings, setRecordings] = useState<Record<string, RecordingInfo>>({});
  const [expiresInS, setExpiresInS] = useState<number | null>(null);

  useEffect(() => {
    if (!ended) return;
    let cancelled = false;
    let tries = 0;
    const load = async () => {
      try {
        const res = await fetch(`/engine/recordings/${encodeURIComponent(code)}`, { cache: "no-store" });
        if (!res.ok) return;
        const body = (await res.json()) as { recordings?: Record<string, RecordingInfo>; expiresInS?: number | null };
        if (cancelled) return;
        setRecordings(body.recordings ?? {});
        setExpiresInS(body.expiresInS ?? null);
        // The voice may still be finishing the last sentence when the session ends.
        if (!Object.keys(body.recordings ?? {}).length && tries++ < 5) window.setTimeout(() => void load(), 2000);
      } catch {
        /* offline: no download offered */
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [code, ended]);

  return { recordings, expiresInS };
}

export function recordingUrl(code: string, lang: string): string {
  return `/engine/recordings/${encodeURIComponent(code)}/${lang}.mp3`;
}
